import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TradesListComponent } from './trades-list/trades-list.component';
import { TradesDetailComponent } from './trades-detail/trades-detail.component';

const routes: Routes = [
    {
        path: 'trades',
        children: [
            { path: '', component: TradesListComponent }
        ]
    },
    {
        path: 'trades/:id',
        children: [
            { path: '', component: TradesDetailComponent }
        ]
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class TradesRoutingModule { }
